import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import { fetchJson } from '../lib/http';
import { formatDate, formatMoney } from '../lib/format';

type Payment = {
	id: string;
	amount: number;
	date: string;
	method: string | null;
	reference: string | null;
	memo: string | null;
	status: string | null;
};

export function PaymentsPage() {
	const [payments, setPayments] = useState<Payment[] | null>(null);
	const [error, setError] = useState('');

	useEffect(() => {
		let cancelled = false;
		(async () => {
			try {
				const data = await fetchJson<Payment[]>('/portal/payments');
				if (!cancelled) setPayments(data);
			} catch (e: any) {
				if (!cancelled) setError('Failed to load payments.');
			}
		})();
		return () => { cancelled = true; };
	}, []);

	return (
		<Layout>
			<div className="rounded-2xl border border-gray-200 bg-white elev-1">
				<div className="p-5 border-b border-gray-100">
					<h1 className="text-2xl font-extrabold text-gray-900">Payments</h1>
				</div>
				<div className="max-h-[70vh] overflow-auto">
					{payments === null ? (
						<div className="p-5 space-y-2">
							{Array.from({ length: 8 }).map((_, i) => (
								<div key={i} className="h-10 rounded-lg bg-gray-100 animate-pulse" />
							))}
						</div>
					) : payments.length === 0 ? (
						<div className="p-6 text-sm text-gray-700">No payments recorded</div>
					) : (
						<table className="min-w-full">
							<thead className="sticky top-0 z-10 bg-gray-50/80 backdrop-blur">
								<tr>
									<th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-600">Date</th>
									<th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-600">Amount</th>
									<th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-600">Method</th>
									<th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-600">Reference</th>
									<th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-600">Status</th>
								</tr>
							</thead>
							<tbody className="divide-y divide-gray-100">
								{payments.map(p => (
									<tr key={p.id} className="odd:bg-white even:bg-gray-50/40 hover:bg-sedra/5 transition-colors">
																			<td className="px-4 py-3 text-sm text-gray-700">{formatDate(p.date)}</td>
									<td className="px-4 py-3 text-sm text-gray-900 font-semibold">{formatMoney(p.amount)}</td>
									<td className="px-4 py-3 text-sm text-gray-700">{p.method || '-'}</td>
									<td className="px-4 py-3 text-sm text-gray-700">{p.reference || '-'}</td>
									<td className="px-4 py-3 text-sm text-gray-700">{p.status || '-'}</td>
									</tr>
								))}
							</tbody>
						</table>
					)}
					{error && <div className="p-6 text-sm text-red-700">{error}</div>}
				</div>
			</div>
		</Layout>
	);
} 